const generateInvoice = ({email, event}) => {
    return new Promise((resolve, reject) => {
        eventHttpClient.post(`/v2/events/${event}/invoices`, { email })
            .then(response => resolve(response))
            .catch(({ response }) => reject(response.data))
            .done();
    });
};

const generateCertificate = ({email, event}) => {
    return new Promise((resolve, reject) => {
        eventHttpClient.post(`/v1/events/${event}/certificates`, {email})
            .then(response => resolve(response))
            .catch(({ response }) => reject(response.data))
            .done();
    });
};


const fetchEvents = type => {
    return new Promise((resolve, reject) => {
        eventHttpClient.get(`/v2/events?filter[type]=${type}`)
            .then(({ data }) => resolve(data))
            .catch(({ response }) => reject(response))
            .done();
    })
};

export default {
    fetchEvents,
    generateInvoice,
    generateCertificate
};
